export const ApplicationName = 'Scisa.Security.Console'

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message',
}

export const LogoutActions = {
  LogoutCallback: 'logoutCallback',
  Logout: 'logout',
  LoggedOut: 'logged-out',
}

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'loginCallback',
  LoginFailed: 'loginFailed',
  Profile: 'profile',
  Register: 'register',
}

const prefix = '/Account'

export const AuthorizationPaths = {
  DefaultLoginRedirectPath: '/',
  ApiAuthorizationPrefix: prefix,
  Login: `${prefix}/${LoginActions.Login}`,
  LoginFailed: `${prefix}/${LoginActions.LoginFailed}`,
  LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
  Register: `${prefix}/${LoginActions.Register}`,
  Profile: `${prefix}/${LoginActions.Profile}`,
  LogOut: `${prefix}/${LogoutActions.Logout}`,
  LoggedOut: `${prefix}/${LogoutActions.LoggedOut}`,
  LogOutCallback: `${prefix}/${LogoutActions.LogoutCallback}`,
  IdentityRegisterPath: '/Identity/Account/Register',
  IdentityManagePath: '/Identity/Account/Manage',
}
